import { useQuery } from '@tanstack/react-query';
import { useAuthContext } from 'modules/auth/context';
import { getReminderSettings } from './api';

/** Keyed by learner, so a second account on the same browser never sees the first's settings. */
export const reminderKey = (userId: string | undefined) => ['study-plan', 'reminder', userId] as const;

/** The daily Telegram reminder settings of the signed-in learner. */
export function useReminderSettings() {
  const { state } = useAuthContext();
  const userId = state.user?.id;
  return useQuery({
    queryKey: reminderKey(userId),
    queryFn: ({ signal }) => getReminderSettings(signal),
    enabled: Boolean(userId),
  });
}
